import React from 'react';

interface CancelIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const CancelIcon: React.FC<CancelIconProps> = ({ 
  width = 14, 
  height = 14, 
  className = '' 
}) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    className={className}
  >
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

export default CancelIcon;

